<template>
  <div>
    <div v-for="rest_home_id in rest_home_ids" :key="rest_home_id">
      <RestHome
        :year="year"
        :month="month"
        :props_charge_period="charge_period"
        :rest_home_id="rest_home_id"
        @period_payment_value="period_payment_value"
        @boleto_period_payment_value="boleto_period_payment_value"
      />
    </div>

    <div class="not-printable text-right">
      <h1>
        Total:
        {{
          formatValueOnKeyUp(
            parseFloat(total_payment_value + total_boleto_payment_value).toFixed(2)
          )
        }}
      </h1>
    </div>
  </div>
</template>

<script>
import RestHome from "./charges/RestHome.vue";

import { formatValueOnKeyUp } from "../../functions/format";

export default {
  name: "RestHomesCharge",

  components: {
    RestHome,
  },

  data() {
    return {
      rest_home_ids: [],

      year: null,

      month: 1,

      charge_period: 1,

      rest_home: {},

      total_payment_value: 0,

      total_boleto_payment_value: 0,
    };
  },

  created() {
    const { ids, year, month, charge_period } =
      this.$router.currentRoute.params;

    if (!ids || !year || !month || !charge_period) {
      this.$router.push({ name: "clients" });
      return;
    }

    let rest_home_ids = ids.split(",");

    this.rest_home_ids = rest_home_ids;

    this.year = year;
    this.month = month;
    this.charge_period = charge_period;

    this.retrieve();
  },

  methods: {
    formatValueOnKeyUp,

    retrieve() {},

    period_payment_value(payment_value) {
      this.total_payment_value = this.total_payment_value + payment_value;
    },

    boleto_period_payment_value(payment_value) {
      this.total_boleto_payment_value = this.total_boleto_payment_value + payment_value;
    },
  },
};
</script>
 
<style scoped>
@media print {
  .not-printable {
    display: none;
  }
}
</style> 